import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation files
import en from './translations/en.json';
import es from './translations/es.json';
import pt from './translations/pt.json';
import fr from './translations/fr.json';
import de from './translations/de.json';
import it from './translations/it.json';
import nl from './translations/nl.json';
import ru from './translations/ru.json';
import ar from './translations/ar.json';

const resources = {
  en: { translation: en },
  es: { translation: es },
  pt: { translation: pt },
  fr: { translation: fr },
  de: { translation: de },
  it: { translation: it },
  nl: { translation: nl },
  ru: { translation: ru },
  ar: { translation: ar }
};

// Get user's preferred language from localStorage
const getUserLanguage = () => {
  try {
    const storedUser = localStorage.getItem('user') || sessionStorage.getItem('user');
    if (storedUser) {
      const user = JSON.parse(storedUser);
      if (user.preferredLanguage) {
        return user.preferredLanguage;
      }
    }
  } catch (error) {
    console.error('Error getting user language:', error);
  }

  // Check localStorage for saved language preference
  const savedLang = localStorage.getItem('i18nextLng');
  if (savedLang) return savedLang;

  return 'en'; // Default to English
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: getUserLanguage(),
    fallbackLng: 'en',

    interpolation: {
      escapeValue: false // React already escapes values
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },

    react: {
      useSuspense: false
    }
  });

// Function to change language and update direction for Arabic
export const changeLanguage = (lng: string) => {
  i18n.changeLanguage(lng);
  localStorage.setItem('i18nextLng', lng);

  // Update direction for Arabic
  if (lng === 'ar') {
    document.documentElement.setAttribute('dir', 'rtl');
    document.documentElement.setAttribute('lang', 'ar');
  } else {
    document.documentElement.setAttribute('dir', 'ltr');
    document.documentElement.setAttribute('lang', lng);
  }
};

// Update language when user logs in
export const updateLanguageFromUser = () => {
  const lang = getUserLanguage();
  changeLanguage(lang);
};

export default i18n;